export const USER_FEATURE_OPTIONS = [
  { key: 'home', label: 'Home / Dashboard' },
  { key: 'post_deal', label: 'Post a Deal / Funding' },
  { key: 'find_deal', label: 'Find a Deal' },
  { key: 'in_progress', label: 'In Progress' },
  { key: 'assets', label: 'Sell Portfolio (LP)' },
  { key: 'chat', label: 'Chat' },
  { key: 'email', label: 'Email' },
  { key: 'files', label: 'Files' },
  { key: 'digest', label: 'Digest' },
  { key: 'payment', label: 'Upgrade Plan' },
  { key: 'settings', label: 'Settings' },
]

export const REJECT_REASONS = [
  { value: 'work_email_required', label: 'Work email required', emailLabel: 'Please register with your corporate work email address.' },
  { value: 'background_check_failed', label: 'Background check failed', emailLabel: 'Your background verification did not pass our review.' },
  { value: 'company_not_verified', label: 'Company could not be verified', emailLabel: 'We could not verify your company information.' },
  { value: 'duplicate_registration', label: 'Duplicate registration', emailLabel: 'This registration appears to be a duplicate account.' },
  { value: 'suspicious_identity', label: 'Identity could not be verified', emailLabel: 'We could not verify your identity details.' },
  { value: 'platform_criteria', label: 'Does not meet platform criteria', emailLabel: 'Your application does not meet our platform criteria at this time.' },
  { value: 'other', label: 'Other', emailLabel: 'Your registration could not be approved at this time.' },
]

/** Always accessible without membership or admin approval */
export const FREE_PORTAL_FEATURES = new Set(['home', 'payment', 'settings'])

/** Requires active membership — page is blurred and blocked when unpaid */
export const MEMBERSHIP_REQUIRED_FEATURES = new Set([
  'post_deal',
  'find_deal',
  'in_progress',
  'assets',
  'email',
  'files',
  'digest',
])

export function defaultFeatureAccessForRole(role) {
  const map = {
    GP: { home: true, post_deal: true, find_deal: true, in_progress: true, assets: false, chat: true, email: true, files: true, digest: true, payment: true, settings: true },
    LP: { home: true, post_deal: false, find_deal: true, in_progress: true, assets: true, chat: true, email: true, files: true, digest: true, payment: true, settings: true },
    Startup: { home: true, post_deal: true, find_deal: false, in_progress: true, assets: false, chat: true, email: true, files: true, digest: true, payment: true, settings: true },
    ServiceProvider: { home: true, post_deal: false, find_deal: false, in_progress: true, assets: false, chat: true, email: true, files: true, digest: true, payment: false, settings: true },
  }
  return { ...(map[role] || map.GP) }
}

export function featureOptionsForRole(role) {
  const defaults = defaultFeatureAccessForRole(role)
  return USER_FEATURE_OPTIONS.filter((opt) => opt.key in defaults)
}

export function isUserPaid(user) {
  return !!(user?.is_paid || user?.company_paid)
}

export function resolveFeatureAccess(user) {
  if (user?.feature_access && typeof user.feature_access === 'object') {
    return user.feature_access
  }
  return defaultFeatureAccessForRole(user?.role)
}

/**
 * @returns {{ locked: boolean, lockType: 'admin'|'paywall'|null, featureKey: string|null, label: string|null }}
 */
export function resolveFeatureLockState(featureKey, user, options = {}) {
  const label = options.label || null
  if (!featureKey || !user) {
    return { locked: false, lockType: null, featureKey: featureKey || null, label }
  }
  if (FREE_PORTAL_FEATURES.has(featureKey)) {
    return { locked: false, lockType: null, featureKey, label }
  }

  const featureAccess = resolveFeatureAccess(user)
  if (featureAccess[featureKey] === false) {
    return { locked: true, lockType: 'admin', featureKey, label }
  }

  if (!isUserPaid(user) && MEMBERSHIP_REQUIRED_FEATURES.has(featureKey)) {
    return { locked: true, lockType: 'paywall', featureKey, label }
  }

  return { locked: false, lockType: null, featureKey, label }
}

export function canAccessFeature(featureAccess, key, user = null) {
  if (!key) return true
  const access = featureAccess || (user ? resolveFeatureAccess(user) : null)
  if (access && access[key] === false) return false
  if (user && !isUserPaid(user) && MEMBERSHIP_REQUIRED_FEATURES.has(key)) return false
  return true
}
